<template>
  <div>
  <b-container>
    <b-form-group @submit.prevent
        :label="$t('deviceTable.filterInputLabel')"
        label-sr-only
        label-for="filterInput"
        class="mb-2 w-50">
        <b-form-input
            v-model="filter"
            type="search"
            id="filterInput"
            size="sm"
            :placeholder="$t('deviceTable.filterDefault')">
        </b-form-input>
    </b-form-group>
    <b-row>
      <b-table id="my-table" striped hover
                border-bottom border-secondary
                show-empty small
                :items="content_list"
                :fields="fields"
                :current-page="currentPage"
                primary-key="guid"
                class="mb-2"
                head-variant="dark"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                thead-class="thead-light"
                tbody-tr-class="text-dark"
                :empty-text="$t('deviceTable.emtpyText')"
                :empty-filtered-text="$t('deviceTable.emptyFilteredText')">

        <template #cell(deviceDetailButton)="row">
          <b-button variant="outline-primary" size="sm"  v-b-tooltip.hover.topright :title="$t('deviceTable.toolTip')"
                    @click="goToDeviceDetailsPage(row.item, row.index)">
            <b-icon icon="pencil-fill"></b-icon>
          </b-button>
        </template>
      </b-table>
    </b-row>
  </b-container>
  </div>
</template>

<script>
import devicesApi from "@/services/devicesApi";
import userApiService from "../services/userApiService";
import store from "@/store/store";
import router from "@/router";

export default {
  name: 'unitDevices',
  props: {
    type: { type: String },
    userId: { type: String }
  },
  data () {
    return {
      totalRows: 0,
      perPage: 0,
      currentPage: 1,
      content_list: [],
      filter: null,
    }
  },
  computed: {
    fields() {
      const baseFields = [
        { key: "hostname", sortable: false, label: "Device Name"},
        { key: "osType", sortable: false, label: "OS"},
        { key: "macAddress", sortable: false, label: "Mac Address"},
        { key: "lastUpdatedTime", sortable: false, label: "Last Seen"},
        { key: "deviceDetailButton", sortable: false, label: ""}
      ]
      
      // Add alias column as the rightmost field (before deviceDetailButton) only if permission is allowed
      if (store.getters.isUpdateClientAliasAllowed) {
        baseFields.splice(-1, 0, { key: "alias", sortable: false, label: "Alias"})
      }
      
      return baseFields
    },
    filterOn() {
      const baseFilterFields = ["macAddress","hostname","osType"]
      // Add alias to filter fields only if permission is allowed
      if (store.getters.isUpdateClientAliasAllowed) {
        baseFilterFields.push("alias")
      }
      return baseFilterFields
    }
  },
  mounted () {
    this.getAllDevices()
  },
  watch: {
    userId: 'updateOnIdChange'
  },
  methods: {
    updateOnIdChange(oldId, newId) {
      if(this.type === 'IDENTITY' && oldId !== newId) {
        this.getAllDevices()
      }
    },
    getAllDevices(){
      if(!store.getters.getIsLoggedIn) {
        return
      }
      if(this.type === 'IDENTITY') {
        userApiService.getAllUserDevices(this.userId).then(result => {
          result.contents.map(device => {
            if(device.lastUpdatedTime != null) {
              device.lastUpdatedTime = new Date(device.lastUpdatedTime).toLocaleString();
            }
          });
          this.content_list = result.contents;
          this.totalRows = result.contents.length;
          this.perPage = result.contents.length;
        })
      } else {
        devicesApi.getDevices(this.type).then(result => {
          result.contents.map(device => {
                if( device.lastUpdatedTime != null) {
                  device.lastUpdatedTime = new Date(device.lastUpdatedTime).toLocaleString();
                }
              });
          this.content_list = result.contents;
          this.totalRows = result.contents.length;
          this.perPage = result.contents.length;
        })
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    goToDeviceDetailsPage(item){
      router.push({ name: 'Device', params: {deviceItem: item}})
    },
    async deleteDevice(item){
      await  devicesApi.deleteDevice(item.guid)
      this.getAllDevices()
    }
  }
}
</script>
